"use strict";

exports.__esModule = true;
exports.mapOOIStylesToManifestStyles = exports.mapOOISettingsToManifestData = exports.mapOOIPresetsToManifestPresets = exports.mapOOIInstallationToManifestInstallation = exports.mapOOIGroupingsToManifestDisplayGroups = exports.mapOOIDisplayFiltersToManifestDisplayFilters = exports.isNumericType = void 0;
var _schema = require("@wix/component-protocol/schema");
var _types = require("../types");
var _conversionUtils = require("./conversion-utils");
var _types2 = require("./types");
const NUMERIC_STYLE_TYPES = new Set([
// layout properties
_types.StyleType.width, _types.StyleType.height, _types.StyleType.gap,
// text properties
_types.StyleType.fontSize, _types.StyleType.fontWeight, _types.StyleType.lineHeight, _types.StyleType.letterSpacing,
// border properties
_types.StyleType.borderWidth, _types.StyleType.borderRadius, _types.StyleType.borderTopLeftRadius, _types.StyleType.borderTopRightRadius, _types.StyleType.borderBottomLeftRadius, _types.StyleType.borderBottomRightRadius, _types.StyleType.borderStartStartRadius, _types.StyleType.borderStartEndRadius, _types.StyleType.borderEndStartRadius, _types.StyleType.borderEndEndRadius,
// margin properties
_types.StyleType.margin, _types.StyleType.marginTop, _types.StyleType.marginRight, _types.StyleType.marginBottom, _types.StyleType.marginLeft, _types.StyleType.marginInlineStart, _types.StyleType.marginInlineEnd,
// padding properties
_types.StyleType.padding, _types.StyleType.paddingTop, _types.StyleType.paddingRight, _types.StyleType.paddingBottom, _types.StyleType.paddingLeft, _types.StyleType.paddingInlineStart, _types.StyleType.paddingInlineEnd,
// non-css properties
_types.StyleType.numberEnum, _types.StyleType.number]);
const isNumericType = type => NUMERIC_STYLE_TYPES.has(type);
exports.isNumericType = isNumericType;
function setCommonValues({
  isMobile,
  defaultValue,
  displayName
}) {
  return {
    ...(typeof isMobile === 'boolean' && {
      defaultValue
    }),
    ...(displayName && {
      displayName
    })
  };
}
function setCustomEnumItem({
  isMobile,
  defaultValue,
  displayName,
  param
}) {
  var _param$options;
  return {
    cssPropertyType: _schema.CSS_PROPERTIES.CSS_PROPERTY_TYPE.customEnum,
    ...setCommonValues({
      isMobile,
      defaultValue,
      displayName
    }),
    customEnum: {
      cssPropertyType: _schema.CSS_PROPERTIES.CSS_PROPERTY_TYPE.string,
      options: (_param$options = param.options) == null ? void 0 : _param$options.map(o => ({
        value: String(o.value),
        displayName: o.displayName
      }))
    }
  };
}
function setNumericItem({
  type,
  isMobile,
  defaultValue,
  displayName,
  param
}) {
  return {
    cssPropertyType: type,
    ...setCommonValues({
      isMobile,
      defaultValue,
      displayName
    }),
    number: param.options
  };
}
const mapOOIStylesToManifestStyles = (params, {
  isMobile,
  paramsData = {}
}) => {
  const styles = {};
  for (const [key, {
    metadata,
    key: DMKey
  }] of Object.entries(params)) {
    const param = paramsData[key] || {};
    const {
      displayName
    } = param;
    const styleItem = (0, _conversionUtils.mapParamToItem)({
      metadata,
      params,
      isMobile: isMobile ?? false,
      validate: type => type in _types.StyleType,
      createItem: (type, defaultValue) => {
        if (type === _types.StyleType.numberEnum ||
        // backward compatibility
        type === _types.StyleType.stringEnum ||
        // backward compatibility
        type === _types.StyleType.customEnum) {
          return setCustomEnumItem({
            isMobile,
            defaultValue,
            displayName,
            param
          });
        }
        if (type === _types.StyleType.booleanValue) {
          return {
            cssPropertyType: _schema.CSS_PROPERTIES.CSS_PROPERTY_TYPE.display,
            display: {
              displayValues: ['block', 'none']
            },
            defaultValue: defaultValue ? 'block' : 'none'
          };
        }
        if (isNumericType(type)) {
          return setNumericItem({
            type,
            isMobile,
            defaultValue,
            displayName,
            param
          });
        }
        return {
          cssPropertyType: type,
          ...setCommonValues({
            isMobile,
            defaultValue,
            displayName
          })
        };
      }
    });
    if (styleItem) {
      styles[DMKey ?? key] = styleItem;
    }
  }
  return styles;
};
exports.mapOOIStylesToManifestStyles = mapOOIStylesToManifestStyles;
const mapOOISettingsToManifestData = (params, {
  isMobile,
  paramsData = {}
}) => {
  const data = {};
  for (const [key, {
    metadata,
    key: DMKey
  }] of Object.entries(params)) {
    const param = paramsData[key] || {};
    const {
      displayName
    } = param;
    const dataItem = (0, _conversionUtils.mapParamToItem)({
      metadata,
      params,
      isMobile: isMobile ?? false,
      validate: type => type in _types.DataType,
      createItem: (type, defaultValue) => {
        const item = {
          dataType: type,
          ...(typeof isMobile === 'boolean' && {
            defaultValue
          }),
          ...(displayName && {
            displayName
          }),
          ...((metadata == null ? void 0 : metadata.dataItemManifestData) || {})
        };
        if (type === _types.DataType.textEnum) {
          item.textEnum = {
            options: param.options
          };
        } else if (type === _types.DataType.number) {
          item.number = param.options;
        }
        return item;
      }
    });
    if (dataItem) {
      data[DMKey ?? key] = dataItem;
    }
  }
  return data;
};
exports.mapOOISettingsToManifestData = mapOOISettingsToManifestData;
const mapOOIGroupingToManifestDisplayGroupItem = (type, restOfGrouping) => {
  switch (type) {
    case 'presets':
      return {
        presets: {
          items: restOfGrouping.presets
        }
      };
  }
  return {};
};
const mapOOIGroupingTypeToManifestGroupType = type => {
  switch (type) {
    case 'presets':
      return _types2.DISPLAY_GROUPS.GROUP_TYPE.presets;
    default:
      throw new Error(`unsupoorted groupType: ${type}`);
  }
};
const mapOOIGroupingsToManifestDisplayGroups = params => params.reduce((acc, {
  id,
  type,
  displayName,
  ...restOfGrouping
}) => ({
  ...acc,
  [id]: {
    groupType: mapOOIGroupingTypeToManifestGroupType(type),
    displayName,
    ...mapOOIGroupingToManifestDisplayGroupItem(type, restOfGrouping)
  }
}), {});
exports.mapOOIGroupingsToManifestDisplayGroups = mapOOIGroupingsToManifestDisplayGroups;
const mapOOIBreakpointStyleToManifestBreakpointStyle = style => Object.fromEntries(Object.entries(style).map(([key, value]) => [key, {
  value
}]));
const mapOOIDisplayFiltersToManifestDisplayFilters = displayFilters => {
  const designActionName = _schema.ACTIONS.ACTION_NAME.design;
  if (!displayFilters) {
    return {
      actions: {
        hide: [designActionName]
      }
    };
  }
  const existingActions = displayFilters.actions;
  if (!existingActions) {
    return {
      ...displayFilters,
      actions: {
        hide: [designActionName]
      }
    };
  }
  if ('hide' in existingActions) {
    return {
      ...displayFilters,
      actions: {
        hide: existingActions.hide.includes(designActionName) ? existingActions.hide : [...existingActions.hide, designActionName]
      }
    };
  }
  if (existingActions.show.includes(designActionName)) {
    const showArray = existingActions.show.filter(action => action !== designActionName);
    return {
      ...displayFilters,
      actions: showArray.length > 0 ? {
        show: showArray
      } : {
        hide: [designActionName]
      }
    };
  }
  return displayFilters;
};
exports.mapOOIDisplayFiltersToManifestDisplayFilters = mapOOIDisplayFiltersToManifestDisplayFilters;
const filterStyleForInnerElement = (style, innerElement) => Object.fromEntries(Object.entries(style).filter(([key, _value]) => (innerElement.elementParams ?? []).some(param => param.key === key)));
const filterStyleForRootElement = (style, innerElements) => Object.fromEntries(Object.entries(style).filter(([key, _value]) => !innerElements.some(innerElement => (innerElement.elementParams ?? []).some(param => param.key === key))));
const mapOOIInnerElementsToManifestElements = (style, innerElements) => innerElements.reduce((acc, innerElement) => {
  const elementStyle = filterStyleForInnerElement(style, innerElement);
  const cssCustomProperties = mapOOIBreakpointStyleToManifestBreakpointStyle(elementStyle);
  return {
    ...acc,
    ...(Object.keys(cssCustomProperties).length ? {
      [innerElement.id]: {
        cssCustomProperties
      }
    } : {})
  };
}, {});
const mapOOIPresetStyleToManifestPresetStyleOverrides = (breakpointStyles, innerElements) => Object.fromEntries(Object.entries(breakpointStyles).map(([breakpoint, style]) => {
  const rootStyle = filterStyleForRootElement(style, innerElements);
  const cssCustomProperties = mapOOIBreakpointStyleToManifestBreakpointStyle(rootStyle);
  const elements = mapOOIInnerElementsToManifestElements(style, innerElements);
  const breakpointStyleOverrides = {
    ...(Object.keys(cssCustomProperties).length ? {
      cssCustomProperties
    } : {}),
    ...(Object.keys(elements).length ? {
      elements
    } : {})
  };
  return [breakpoint, breakpointStyleOverrides];
}).filter(([_, breakpointStyleOverrides]) => Object.keys(breakpointStyleOverrides).length));
const mapOOIBreakpointToManifestBreakpoint = breakpoint => {
  switch (breakpoint) {
    case _types.Breakpoint.small:
      return _types2.LAYOUT.BREAKPOINT.small;
    case _types.Breakpoint.large:
      return _types2.LAYOUT.BREAKPOINT.large;
    default:
      return _types2.LAYOUT.BREAKPOINT.UNKNOWN_Breakpoint;
  }
};
const mapOOIPresetOptimizedForToManifestOptimizedFor = optimizedFor => (optimizedFor ?? []).map(mapOOIBreakpointToManifestBreakpoint);
const mapOOIPresetsToManifestPresets = (params, innerElements) => params.reduce((acc, {
  id,
  style,
  optimizedFor,
  ai,
  ...resetOfPresetConfig
}) => {
  const mappedOptimizedFor = mapOOIPresetOptimizedForToManifestOptimizedFor(optimizedFor);
  const styleOverrides = mapOOIPresetStyleToManifestPresetStyleOverrides(style, innerElements);
  return {
    ...acc,
    [id]: {
      ...resetOfPresetConfig,
      ...(mappedOptimizedFor.length ? {
        optimizedFor: mappedOptimizedFor
      } : {}),
      ...(Object.keys(styleOverrides).length ? {
        styleOverrides
      } : {})
    }
  };
}, {});
exports.mapOOIPresetsToManifestPresets = mapOOIPresetsToManifestPresets;
const mapOOIInstallationToManifestInstallation = installation => {
  const {
    presets,
    ...restOfInstallation
  } = installation;
  return {
    ...restOfInstallation,
    ...(presets ? {
      presets: {
        // @ts-expect-error - TODO: remove error when default type is merged
        default: presets.default ?? null,
        large: presets.default ?? null,
        small: presets.small ?? null
      }
    } : {})
  };
};
exports.mapOOIInstallationToManifestInstallation = mapOOIInstallationToManifestInstallation;
//# sourceMappingURL=manifest-mappers.js.map